"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

// Optional: customize NProgress
NProgress.configure({ showSpinner: false, trickleSpeed: 100 });

const ProgressBar = () => {
  const pathname = usePathname();

  useEffect(() => {
    // Start progress on route change
    NProgress.start();

    // Stop progress when pathname updates
    NProgress.done();

    return () => {
      NProgress.done(); // in case of unmount
    };
  }, [pathname]);

  return null;
};

export default ProgressBar;
